import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  background: ${Colors.white};
  border-right: 1px solid ${Colors.blue[20]};
  height: 100%;
  padding: ${Spacing.M} 0rem;
  width: 20rem;
`;
